import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import { link } from '@helpers/typography';
import svgTick from '@img/icons/background/tick.svg?url';
import styled, { css } from 'styled-components';
export const CommonCheckboxContainerStyles = css `
  display: flex;
  flex-wrap: wrap;
  gap: ${fluid(12, 16)} ${fluid(24, 48)};

  flex-direction: column;

  @media ${from(Device.Tablet)} {
    flex-direction: row;
  }

  &[data-layout='vertical'] {
    flex-direction: column;
  }
`;
const Container = styled.div `
  ${CommonCheckboxContainerStyles};
`;
const Option = styled.div `
  display: flex;

  @media ${from(Device.Tablet)} {
    white-space: nowrap;
  }
`;
const Input = styled.input `
  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  ${srOnly};
`;
export const CommonCheckboxLabelStyles = css `
  ${fonts.daxWide.regular};

  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: ${fluid(16, 18)};
  line-height: 1em;
  color: var(--textColor);

  &::before {
    content: '';
    display: inline-block;
    height: 17px;
    background: ${brand.global.white} no-repeat center center;
    background-size: 12px 12px;
    border: 1px solid var(--borderColour);
    color: var(--textColor);
    margin-right: ${fluid(10, 12)};
    width: 17px;
    border-radius: 4px;
    flex-shrink: 0;
  }

  a {
    ${link};
  }

  ${Input}:checked + &::before {
    background-color: ${brand.global.white};
    background-image: url(${svgTick});
  }

  [data-site='ess'] & {
    --borderColour: ${brand.ess.secondary.darkGrey};
    --textColor: ${brand.ess.primary};
  }

  [data-site='mep'] & {
    --borderColour: ${brand.mep.secondary.darkestGrey};
    --textColor: ${brand.mep.primary};
  }

  [data-layout='vertical'] & {
    width: 100%;
  }
`;
const Label = styled.label `
  ${CommonCheckboxLabelStyles};
`;
const CheckboxListStyles = {
    Container,
    Input,
    Label,
    Option,
};
export default CheckboxListStyles;
